import React, { useEffect, useRef } from 'react';
import { usePage } from '@inertiajs/inertia-react';

const MapMarker = (data) => {
     function createMarker(){
          let position = {lat:parseFloat(data.lat), lng:parseFloat(data.lon)};
          console.log(data);
          new window.google.maps.Marker({
               position: position,
               map: googleMap,
               animation: window.google.maps.Animation.DROP,
               title: `${data.title}`,
               icon : data.marker,
          });
     }

     return (
          createMarker()
     );
}

export default MapMarker;
